<div class="deal-summary">
    <woa-icon class="deal-summary-icon" [name]="'tags'"></woa-icon>
    @if (dealModel.appliedDeals().length) {
        <div class="deal-summary-count">{{ dealModel.appliedDeals().length }}</div>
    }
</div>
